<template>
  <div class="md:mx-4 lg:mx-8 text-dark">
    <div class="text-center ">


        <div class="flex items-center justify-center">
          <img src="@/assets/images/4day.png" alt="Image" class="mx-auto w-full lg:w-2/3">

        </div>
        <h3 class="text-2xl font-black text-black mt-2">streak</h3>

        <h1 class="text-5xl font-black text-black mb-2">4 days</h1>

        <div class="my-6">
            Anyone can take the first step, but continuing takes courage and resilience. And you've proven that you have what it takes.
        </div>

        <div class="flex items-center justify-center mt-4">
            <vs-button icon-pack="feather" icon="icon-arrow-right" @click="save">keep going</vs-button>
        </div>

        <div class="font-italic font-sm mt-2">
          *Being successful is like having a great joke, it's better when you share it with others.
        </div>
    </div>
  </div>

</template>

<script>

export default {
  components: {
  },
  data () {
   return {
    }
  },
  computed: {
  },
  methods: {
    save () {
      this.$emit('hidePopup')
    }
  }
}
</script>
